import { Flag, Sparkles, Wrench, Zap } from 'lucide-react';
import { useTheme } from '@/theme/ThemeProvider';

/** Tasarıma göre marka işareti */
export function BrandIcon({ size = 18 }: { size?: number }) {
  const { design } = useTheme();
  switch (design.id) {
    case 'obsidian': return <Zap size={size} strokeWidth={2.5} className="text-black" />;
    case 'ledger': return <span className="brand-letter font-bold" style={{ fontSize: size * 0.85 }}>D</span>;
    case 'pitstop': return <Flag size={size} className="text-white" />;
    case 'atelier': return <Wrench size={size} className="text-white" />;
    default: return <Sparkles size={size} className="text-white" />;
  }
}
